import $api from '../services';

export default {
    getApiKey() {
        return $api.get('/get_api_key');
    },
};
